module.exports = __webpack_public_path__ + "img/demo_cover.c9208abb.png";